var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reg-checkbox",class:{ 'is-checked': _vm.checked, 'is-disabled': _vm.disabled },on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }